import { Extension } from '@tronic-sdk/commons';
import { createDuplicateIframeWarning } from '@tronic-sdk/provider';
import { UILauncherConfig } from './types';

function findSameSrcInstances(parameters: string) {
  const iframes: HTMLIFrameElement[] = [].slice.call(document.querySelectorAll('.tronic-ui-launcher-iframe'));
  const iframe = iframes.find((i) => i.src.includes(parameters));
  return iframe;
}

const overlayStyles: Partial<CSSStyleDeclaration> = {
  display: 'block',
  position: 'fixed',
  right: '0px',
  left: '0px',
  bottom: '0px',
  width: '84px',
  height: '92px',
  border: 'none',
  zIndex: '2147483647',
  cursor: 'pointer',
  overflow: 'visible',
  background: 'transparent',
};

/**
 * Apply iframe styles to the given element.
 * @param elem - An element to apply styles using CSSOM.
 */
function applyStyles(elem: HTMLElement, config: UILauncherConfig) {
  for (const [cssProperty, value] of Object.entries(overlayStyles)) {
    // TODO: this is a quick and dirty way to handle layout, probably needs to be improved with css
    if (['left', 'right'].includes(cssProperty) && config.position === cssProperty) {
      /* eslint-disable-next-line no-param-reassign */
      (elem.style as any)[cssProperty as any] = value;
    } else if (!['left', 'right'].includes(cssProperty)) {
      /* eslint-disable-next-line no-param-reassign */
      (elem.style as any)[cssProperty as any] = value;
    }
  }
}

export class UILauncherExtension extends Extension.Internal<'uiLauncher', any> {
  private iframe?: Promise<HTMLIFrameElement>;
  name = 'uiLauncher' as const;
  config: UILauncherConfig = {
    position: 'right',
  };
  compat = {
    'tronic-sdk': true,
  };

  constructor(private uiLauncherConfig: UILauncherConfig = {}) {
    super();

    this.config = {
      ...this.config,
      ...uiLauncherConfig,
    };
  }

  public mount = () => {
    this.iframe = new Promise((resolve) => {
      const onload = async () => {
        // @ts-ignore - this.sdk.parameters is marked protected but we need to access it.
        const { parameters } = this.sdk;
        const sameSrcInstance = findSameSrcInstances(parameters);

        if (!sameSrcInstance) {
          const iframe = document.createElement('iframe');
          iframe.classList.add('tronic-ui-launcher-iframe');
          iframe.title = 'Secure Modal';
          iframe.frameBorder = '0';
          iframe.setAttribute('allowtransparency', 'true');
          iframe.src = this.utils.createURL(
            // @ts-ignore - this.sdk.endpoint is marked protected but we need to access it.,
            `${this.sdk.endpoint}/sdk/extensions/ui-launcher?params=${parameters}`,
          ).href;
          applyStyles(iframe, this.config);
          document.body.appendChild(iframe);

          // @ts-ignore
          const container = (await this.overlay.elements)[1];
          container.classList.remove('right');
          container.classList.remove('left');
          container.classList.add(this.config.position);

          resolve(iframe);
        } else {
          createDuplicateIframeWarning().log();
          resolve(sameSrcInstance);
        }
      };

      // Check DOM state and load...
      if (['loaded', 'interactive', 'complete'].includes(document.readyState)) {
        onload();
      } else {
        // ...or check load events to load
        window.addEventListener('load', onload, false);
      }
    });
  };

  public show = async () => {
    const iframe = await this.iframe;
    if (iframe) {
      iframe.style.display = 'block';
    }
  };

  public hide = async () => {
    const iframe = await this.iframe;
    if (iframe) {
      iframe.style.display = 'none';
    }
  };
}
